import React from 'react';
import { riskStatusKey } from './RiskBadge';

/**
 * 위험도 신호등. 규격: docs/design.md 6.6 (신호등 변형)
 *
 * 대시보드 표처럼 열이 많아 글자를 넣을 자리가 없을 때 색 원 하나로 단계를 보인다.
 * 수치와 단계 이름은 title(툴팁)과 aria-label 로 남긴다 — 색만으로 정보를 전하지 않기 위해서다.
 * 색은 getRiskLevel().color 를 쓰지 않고 level 문자열 → 토큰 클래스로 정한다.
 *
 * <RiskDot level="위험 (고혈압)" title="수축기: 152 (위험 (고혈압))" />
 *
 * 범례처럼 옆에 이미 같은 말이 글자로 붙어 있으면 decorative 를 준다 — 스크린 리더가
 * "위험, 위험" 처럼 두 번 읽지 않도록 role/aria-label/title 대신 aria-hidden 만 단다.
 * 표 안의 데이터 점은 그대로 둔다 — 거기서는 접근성 이름이 유일한 텍스트 대안이다.
 */
export default function RiskDot({ level, title, className = '', decorative = false }) {
    const key = riskStatusKey(level);
    const label = title || level || '기록 없음';
    if (decorative) {
        return <span className={`sds-dot sds-dot--${key} ${className}`.trim()} aria-hidden="true" />;
    }
    return (
        <span
            className={`sds-dot sds-dot--${key} ${className}`.trim()}
            role="img"
            aria-label={label}
            title={label}
        />
    );
}

/** 혈압처럼 원이 둘 이상 나란히 올 때. items: [{ level, title }] */
export function RiskDots({ items = [], className = '' }) {
    return (
        <span className={`sds-dots ${className}`.trim()}>
            {items.map((item, index) => (
                <RiskDot key={index} level={item.level} title={item.title} />
            ))}
        </span>
    );
}
